<template>

    <div>
        <div class="row">
            <div v-if="extent_id_from_blade" class="col-md-12 ">
                Using extent from URL. <a href="/assignments">Use persistent extent instead</a>.
            </div>
            <div v-else class="col-md-12 ">
                <ExtentList @checkChange="handleCheckChangeParent" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Assignments</div>
                    <div class="panel-body">
                        <el-button @click="download">Download content manifest</el-button>
                        <el-button @click="rules" type="warning" v-if="selected_extent_state!=='archived'">Refine rules</el-button>
                      <span style="margin-left:10px;">Note: in the charts below "NO VALUE" means that these are content items that have not yet been assigned.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="extent_id">
            <div class="col-md-4 ">
                <div class="panel panel-default">
                    <div class="panel-heading"><strong>Buckets</strong> <em>What is the content we are transforming? </em>
                    </div>
                    <div class="panel-body">
                        <SingleFieldBarChart
                                :height=400
                                :extent_id="extent_id"
                                :chart_config = "chartConfigBucket"
                                :version="version"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-4 ">
                <div class="panel panel-default">
                    <div class="panel-heading"><strong>Dispositions</strong> <em>How will we treat the content?</em></div>
                    <div class="panel-body">
                        <SingleFieldBarChart
                                :height=400
                                :extent_id="extent_id"
                                :chart_config = "chartConfigDisposition"
                                :version="version"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-4 ">
                <div class="panel panel-default">
                    <div class="panel-heading"><strong>Resourcing</strong> <em>Who will do the work?</em></div>
                    <div class="panel-body">
                        <SingleFieldBarChart
                                :height=400
                                :extent_id="extent_id"
                                :chart_config = "chartConfigResourcing"
                                :version="version"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ">
              <div class="panel panel-default">
                  <div class="panel-heading"><strong>Effort</strong>
                    <em>What is the per-content-item effort (NOT calendar duration) per disposition?
                      <br />
                      <span style="color:gray">Note: there may be additional site-wide setup effort, and this does not include coding/scripting time.</span>
                    </em></div>
                  <div class="panel-body">
                    <SingleFieldBarChart
                        :height=400
                        :extent_id="extent_id"
                        :chart_config = "chartConfigEffort"
                        :version="version"
                    />
                  </div>
              </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12 ">
            <div class="panel panel-default">
              <div class="panel-heading"><strong>Buckets to Dispositions</strong> <em>How will the different buckets be treated?</em></div>
              <div class="panel-body">
                <SingleFieldBarChart
                    :height=600
                    :extent_id="extent_id"
                    :chart_config = "chartConfigSankey"
                    :version="version"
                    :width="1108"
                />
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['extent_id_from_blade'],
        mounted() {
        },
        computed: {
            extent_id: function () {
                if (this.extent_id_from_blade) {
                    return this.extent_id_from_blade
                } else {
                    return this.selected_extent_id
                }
            },
        },
        watch: {
            extent_id: function(val) {
                console.log("hello")
                // this.loadEstimate()
                this.version = this.version + 1
            }
        },
        methods: {
            download() {
                console.log('clicked button')
                window.open('/extents/manifest/' + this.extent_id,"_blank")
            },
            loadEstimate() {
                axios.get('/estimate/' + this.extent_id)
                    .then(response => {
                        console.log("the estimate:")
                        console.log(response.data)
                        this.estimated_hours = response.data
                    })
                    .catch(error => {
                        console.log('oops getting metadata')
                    })
            },
            handleCheckChangeParent(selected_extent) {
                this.selected_extent_id = selected_extent.id
                this.selected_extent_state = selected_extent.state
            },
            listener() {
                console.log('listen')
            },
            rules() {
                window.location.href = "/rules"
            }
        },
        data() {
            return {
                selected_extent_id: null,
                selected_extent_state: '',
                estimated_hours: "not yet computed",
                chartConfigBucket: {
                    field_name: 'bucket',
                    chart_type: 'horizontalbar'
                },
                chartConfigDisposition: {
                    field_name: 'disposition',
                    chart_type: 'horizontalbar'
                },
                chartConfigResourcing: {
                    field_name: 'resourcing',
                    chart_type: 'horizontalbar'
                },
                chartConfigEffort: {
                    field_name: 'disposition',
                    chart_type: 'bar',
                    agg_function: 'sum',
                    size_field: 'effort'
                },
                chartConfigSankey: {
                    group_by_field: 'bucket',
                    field_name: 'disposition',
                    chart_type: 'sankey'
                },
                version: null,
            }
        },
    }
</script>